import React from "react";
import { RentPaymentScreenContainer } from "src/containers";

export const RentPaymentScreen = () => {
  return <RentPaymentScreenContainer />;
};
